import React from "react";
import { SkyLoader } from "@skypointcloud/skypoint-ui";

interface LoaderProps {
  labelPosition?: "above" | "below" | "before" | "after";
  label?: string;
  size?: "tiny" | "extra-small" | "small" | "medium" | "large" | "extra-large" | "huge";
}

const Loader = ({
  labelPosition = "below",
  label = "Loading...",
  size = "large",
}: LoaderProps): React.ReactElement => {
  return (
    <SkyLoader
      labelPosition={labelPosition}
      label={label}
      size={size}
    />
  );
};

export default Loader;
